import * as ko from "knockout";

export class product_related_places {
  sequence: KnockoutObservable<string>;
  contr_driven: KnockoutObservable<string>;
  default_rel: KnockoutObservable<string>;
  place_id: KnockoutObservable<string>;
  product_id: KnockoutObservable<string>;
  rel_type: KnockoutObservable<string>;
  rel_type_description: KnockoutObservable<string>;
  address_id: KnockoutObservable<string>;
  address_details: KnockoutObservable<string>;
  type: KnockoutObservable<"USER" | "PRODUCT">;

  constructor(item) {
    this.type = ko.observable(item?.type || "PRODUCT");
    this.sequence = ko.observable(item.sequence);
    this.contr_driven = ko.observable(item.contr_driven);
    this.default_rel = ko.observable(item.default_rel);
    this.place_id = ko.observable(item.place_id);
    this.product_id = ko.observable(item.product_id);
    this.rel_type = ko.observable(item.rel_type);
    this.rel_type_description = ko.observable(item.rel_type_description ? item.rel_type_description : "");
    this.address_details = ko.observable(
      item.c_product_place_rel_contr_detail_view ? item.c_product_place_rel_contr_detail_view.address_details : ""
    );
    this.address_id = ko.observable(
      item.c_product_place_rel_contr_detail_view ? item.c_product_place_rel_contr_detail_view.address_id : ""
    );
  }
}
